// Lightweight client for the user's watch + search history.
//
// All endpoints require auth. Calls fail silently for anonymous users
// so the rest of the app never crashes — history is a "nice to have"
// for signed-in users, not a hard requirement.
import api from "./api";

export async function logWatch({ id, type, title, subtitle, thumbnail }) {
  if (!id) return;
  try {
    await api.post("/history/watch", {
      item_id: id,
      item_type: type || "",
      title: title || "",
      subtitle: subtitle || "",
      thumbnail: thumbnail || "",
    });
  } catch (_) { /* silent for anon users */ }
}

export async function logSearch(query, resultCount) {
  if (!query || query.trim().length < 2) return;
  try {
    await api.post("/history/search", { query, result_count: resultCount ?? 0 });
  } catch (_) { /* silent */ }
}

export async function listHistory(kind) {
  const params = kind ? { kind } : {};
  const { data } = await api.get("/history/me", { params });
  return data.items || [];
}

export async function clearHistory(kind) {
  const params = kind ? { kind } : {};
  const { data } = await api.delete("/history/me", { params });
  return data.deleted || 0;
}

export async function deleteHistoryItem({ kind, itemId, query }) {
  const body = { kind };
  if (kind === "watch") body.item_id = itemId;
  if (kind === "search") body.query = query;
  const { data } = await api.delete("/history/me/item", { data: body });
  return data.deleted || 0;
}
